export default "__VITE_ASSET__2404465b__"